import PagedRequest, { PagedResponse } from "../requests";

export class GetUsersRequest extends PagedRequest {}

export class GetUsersResponse extends PagedResponse<UserListResource> {
  constructor(users: UserListResource[], total: number = 0) {
    super();
    this.items = users;
    this.totalItems = total;
  }
}

export class SearchUsersRequest extends PagedRequest {
  name: string;
}

export interface UserListResource {}

export interface UserResource {
  id: number;
  externalId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  role?: UserRoleResource;
}

export interface UserRoleResource {
  id: number;
  name: string;
}

export class SaveUserRequest {
  id?: number = null;
  externalId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  roleId: number;

  get isNew() {
    return this.id === null;
  }
}

export interface SaveUserResponse {
  id: number;
}
